import { Divider, List, ListItem, ListItemText, Snackbar, Typography } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';
import useData from './hooks';
import { InfoBubbleContentSx } from './styles';

const ApplicationInfo = ({ apiInfo }: { apiInfo: Record<string, unknown> | undefined }) => {
  const { t } = useTranslation('userSetting');
  const { versionText, handleVersionClick, infoBubbleMessage, isInfoBubbleOpen, closeInfoBubble } = useData();

  return (
    <>
      <List
        sx={{ width: '100%', bgcolor: 'background.paper' }}
        component="nav"
        aria-labelledby="nested-list-subheader"
        subheader={
          <Typography component="div" id="nested-list-subheader" sx={{ color: '#FF8C00' }}>
            {t('qcapp_preference_category_appinfos')}
          </Typography>
        }
      >
        <ListItem>
          <ListItemText
            primaryTypographyProps={{ variant: 'subtitle1', fontWeight: 'bold' }}
            primary={t('qcapp_client_web_name')}
            secondary={
              <Typography
                sx={{ display: 'inline', cursor: 'pointer', userSelect: 'none' }}
                component="span"
                variant="body2"
                onClick={handleVersionClick}
              >
                {versionText}
              </Typography>
            }
          />
        </ListItem>
        <Divider variant="fullWidth" />
        <ListItem>
          <ListItemText
            primaryTypographyProps={{ variant: 'subtitle1', fontWeight: 'bold' }}
            primary={t('qcapp_preference_appinfos_api')}
            secondary={
              apiInfo &&
              Object.keys(apiInfo).map((key, index) => {
                return (
                  <Typography key={index} sx={{ display: 'block' }} component="span" variant="body2">
                    {`${key} : ${apiInfo[key]}`}
                  </Typography>
                );
              })
            }
          />
        </ListItem>
      </List>

      <Snackbar
        open={isInfoBubbleOpen}
        onClose={closeInfoBubble}
        autoHideDuration={1800}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
        message={infoBubbleMessage}
        ContentProps={{
          sx: InfoBubbleContentSx,
        }}
      />
    </>
  );
};
export default ApplicationInfo;
